import {
  U21FormField,
  U21FormFieldTypes,
  U21Spacer,
  useU21FormState,
} from 'app/shared/u21-ui/components';
import { useSelector } from 'react-redux';

import { required } from 'app/shared/utils/validation';
import { selectAgent } from 'app/modules/session/selectors';
import { useMemo } from 'react';
import { SaveFilterFormValues } from 'app/modules/filters/models';
import { SHARING_PRIVATE, SHARING_TEAMS } from 'app/modules/filters/constants';

export const SaveFilterFormContent = () => {
  const agent = useSelector(selectAgent);
  const { values } = useU21FormState<SaveFilterFormValues>({
    subscription: { values: true },
  });

  const teamOptions = useMemo(
    () =>
      agent.teams.map((team) => ({
        text: team.name,
        value: team.id,
      })),
    [agent],
  );

  return (
    <U21Spacer spacing={2}>
      <U21FormField
        label="Title"
        name="title"
        required
        type={U21FormFieldTypes.TEXT}
        validate={required('Filter title is required.')}
        fieldProps={{
          autoFocus: true,
          inputProps: { maxLength: 255 },
          placeholder: 'Name your saved filter...',
        }}
      />
      <U21FormField
        label="Description"
        name="description"
        type={U21FormFieldTypes.TEXT}
        fieldProps={{
          inputProps: { maxLength: 255 },
          placeholder: 'Add a short description...',
        }}
      />
      <U21FormField
        label="Visibility"
        name="sharing"
        type={U21FormFieldTypes.RADIO_GROUP}
        fieldProps={{
          horizontal: true,
          options: [
            { label: 'Private', value: SHARING_PRIVATE },
            {
              disabled: !teamOptions.length,
              label: 'Shared with teams',
              tooltip: !teamOptions.length
                ? 'Join a team to share filters.'
                : undefined,
              value: SHARING_TEAMS,
            },
          ],
        }}
      />
      {values.sharing === SHARING_TEAMS && (
        <U21FormField
          label="Teams"
          name="team_ids"
          required
          type={U21FormFieldTypes.MULTISELECT}
          validate={(v: number[] | undefined) =>
            v && v.length > 0 ? undefined : 'Select at least one team.'
          }
          fieldProps={{
            options: teamOptions,
            placeholder: 'Select teams to share with...',
          }}
        />
      )}
    </U21Spacer>
  );
};
